import React from 'react'
import './MenuToggle.scss'

export const MenuToggle = props => {

    const cls = [
        'fa',
    ]


    if (props.isOpen) {
        cls.push('fa-times')
        cls.push('menuToggleOpen')
    } else {
        cls.push('fa-bars')
    }

    return (
        <i
            className={cls.join(' ')}
            onClick={() => props.setOpen(!props.isOpen)}
        />
    )
}
